import { initializeApp } from "firebase/app";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
  apiKey: "AIzaSyDou7F2_fiPuJk5sVtBN-T15Bfy2VaZPTU",
  authDomain: "pdf-store-35ee3.firebaseapp.com",
  projectId: "pdf-store-35ee3",
  storageBucket: "pdf-store-35ee3.appspot.com",
  messagingSenderId: "647885955305",
  appId: "1:647885955305:web:9feb380fd51f30a42bd078",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const storage = getStorage(app);
